/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Player_NameInputs */



/**
* | output |
* | --- |
* | "Player name" |
*
* @param {Offline_Player_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_player_name = /** @type {((inputs?: Offline_Player_NameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Player_NameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome do jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del giocatore")
	return /** @type {LocalizedString} */ ("Player name")
});